const noDataMixin = {
  filters: {
    GenericMessage(value) {
      return value || "Sem Informação";
    }
  }
};

export default noDataMixin;
